import { Link as RouterLink } from "react-router-dom";

/** Props that make a NoticeboardButton a router link, which its own props don't cover. */
export const routerLinkProps = (to: string) =>
  ({ component: RouterLink, to }) as Record<never, never>;
